import {
  Button,
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateFooter,
  EmptyStateTitle,
  Link,
  Page,
  PageBody,
  PageHeader,
  PageHeaderActions,
  PageHeaderIconTile,
  PageHeaderTitle,
} from '@customerio/pluma-components/react';
import { DocumentTitle } from '@/components/page/document-title';
import { AddCollectionButton, CollectionsTable } from '@/features/collections';
import { useCollections } from '@/services/db/collection/queries';
import { useWorkspaceIdFromCurrentUrl } from '@/services/router/use-workspace-id';

const DOCS_URL = 'https://docs.customer.io/journeys/collections/';
const DOCS_API_URL = 'https://docs.customer.io/journeys/collections/#collections-api';

export default function CollectionsIndexPage() {
  const workspaceId = useWorkspaceIdFromCurrentUrl() ?? 0;
  // One workspace-id source for the query and every mutation, so a workspace
  // transition can't show one workspace's collections while mutating another.
  const { data: collections } = useCollections({ workspaceId });
  const existingNames = collections.map((collection) => collection.name);

  return (
    <>
      <DocumentTitle title="Collections" />
      <Page flexGrow="1">
        <PageHeader>
          <PageHeaderIconTile name="database" />
          <PageHeaderTitle>Collections</PageHeaderTitle>
          <PageHeaderActions>
            <AddCollectionButton workspaceId={workspaceId} existingNames={existingNames} />
          </PageHeaderActions>
        </PageHeader>
        <PageBody>
          {collections.length > 0 ? (
            <CollectionsTable collections={collections} workspaceId={workspaceId} />
          ) : (
            <EmptyState>
              <EmptyStateTitle icon="database">Use your business data in your messages</EmptyStateTitle>
              <EmptyStateDescription>
                Add a Collection for things in your business, like a list of upcoming events, promotions, or available
                classes to use in your messages.
              </EmptyStateDescription>
              <EmptyStateActions>
                <AddCollectionButton workspaceId={workspaceId} existingNames={existingNames} />
                <Button variant="secondary" href={DOCS_API_URL}>
                  View API docs
                </Button>
              </EmptyStateActions>
              <EmptyStateFooter>
                <Link href={DOCS_URL}>Learn more about Collections</Link>
              </EmptyStateFooter>
            </EmptyState>
          )}
        </PageBody>
      </Page>
    </>
  );
}
